import { makeStyles } from "@mui/styles";
import { BORDER_RADIUS } from "../../theme";

export const useStyles = makeStyles(() =>({
    modal: {
        border: "1px solid rgba(57, 57, 72, 0.6)",
        borderRadius: BORDER_RADIUS.XL
    }
}));